import React, { useContext } from 'react'
import styled from 'styled-components'
import AppContext from 'context'
import NumDisplay from 'components/num-display'
import mixins from 'utils/mixins'
import { determineColor, moneyFormat } from 'utils/helpers'

const GrandTotals = styled.div`
  ${mixins.card}
`

const Flex = styled.div`
  display: flex; 
  justify-content: space-around;
`

// TODO: refactor calculations to be more reusable - this is a start.
// Refactor to a helper and use in report.js
const calcCashflowTotals = (sectionItems, key) => Object.values(sectionItems)
  .reduce((p, c) => p += c.frequency === 'Annually' 
      ? c[key] / 12
      : c[key]
  , 0)

export default () => {
  const { state } = useContext(AppContext)

  const grandTotals = Object.entries(state.worksheet_data).reduce((prev, curr) => {
    const [k, vals] = curr
    if (k === 'Income') {
      prev.current += calcCashflowTotals(vals, 'current')
      prev.projected += calcCashflowTotals(vals, 'projected')  
    } else {
      prev.current -= calcCashflowTotals(vals, 'current')
      prev.projected -= calcCashflowTotals(vals, 'projected')
    }
    return prev
  }, {current: 0, projected: 0})

  return (
    <GrandTotals>
      <h2 style={{textAlign: 'center'}}>Grand Totals</h2>
      <hr/>
      <Flex>
        <NumDisplay
          className="grand"
          bigNum={`${moneyFormat.to(grandTotals.current)}`}
          heading="current"
          style={{textAlign: 'center'}}
        />
        <NumDisplay
          className="grand"
          bigNum={`${moneyFormat.to(grandTotals.projected)}`}
          heading="projected"
          style={{textAlign: 'center'}}
        />
        <NumDisplay
          className="grand"
          bigNum={`${moneyFormat.to(grandTotals.projected - grandTotals.current)}`} 
          heading="difference" 
          style={{textAlign: 'center', color: determineColor(grandTotals.projected - grandTotals.current)}} 
        />
      </Flex>
    </GrandTotals>
  )
}